import { Box } from '@chakra-ui/react';

import { Divider } from 'uiToolkitV1/Divider';
import { ListRadio } from 'uiToolkitV1/ListRadio';

export interface ListRadioWithContentProps {
  onChange: (index: number) => void;
  checkedIndex?: number;
  items: Array<{
    title: string;
    subtitle?: string;
    content?: React.ReactNode;
    rightContentComp?: React.ReactNode;
  }>;
}

export const ListRadioWithContent = ({ onChange, checkedIndex = 0, items }: ListRadioWithContentProps) => {
  const handleChange = (index: number) => {
    if (index === checkedIndex) {
      return;
    }

    onChange(index);
  };

  return (
    <Box>
      {items.map((item, i) => (
        <Box key={i}>
          <ListRadio
            label={item.title}
            subText={item.subtitle}
            rightContentComp={item.rightContentComp}
            checked={i === checkedIndex}
            // onClick={() => {}}
            onClick={() => handleChange(i)}
            isBoldText
          />
          {checkedIndex === i && item.content && (
            <Box pl="44px" pt={2}>
              {item.content}
            </Box>
          )}
          {i !== items.length - 1 && <Divider mx={3} />}
        </Box>
      ))}
    </Box>
  );
};
